import React from "react";

const UploadDocumentsPreview = ({ blockItems = [] }) => {
    const uploadedItems = blockItems.filter(
        (item) =>
            String(item?.fileName || "").trim().length > 0 ||
            String(item?.fileUrl || "").trim().length > 0,
    );

    if (!uploadedItems.length) return null;

    return (
        <div className="upload-documents-preview">
            {uploadedItems.map((item, idx) => {
                const fileName = item?.fileName || "Document";
                const fileUrl = item?.fileUrl || "";

                return (
                    <div className="upload-documents-preview-item" key={`${fileName}-${idx}`}>
                        {fileUrl ? (
                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                {fileName}
                            </a>
                        ) : (
                            <span>{fileName}</span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default UploadDocumentsPreview;
